<template>
    <div class="app-container">
        <div class="wrap">
            <navBar title="回款详情" @handleGoBack="handleGoBack"></navBar>
            <div class="add-form">
                <van-form validate-first>
                    <van-field
                            v-model="formInline.endTime"
                            label="到账日期"
                            disabled
                    />
                    <van-field
                            v-model="formInline.number"
                            label="总回款期数"
                            disabled
                    />
                    <van-field
                            v-model="formInline.currentNumber"
                            label="当前回款期数"
                            disabled
                    />
                    <van-field
                            v-model="formInline.collectionPrice"
                            label="总金额"
                            disabled
                    />
                    <van-field
                            v-model="formInline.collectionPrice"
                            label="已还金额"
                            disabled
                    />
                    <van-field
                            v-model="formInline.notYerPrice"
                            label="待还金额"
                            disabled
                    />
                    <van-field
                            v-model="formInline.name"
                            label="关联计划"
                            disabled
                    />
                    <van-field
                            v-model="formInline.order"
                            label="关联订单"
                            disabled
                    />
                    <van-field
                            v-model="formInline.customer"
                            label="关联客户"
                            disabled
                    />
                    <van-field
                            v-model="formInline.state"
                            label="回款状态"
                            disabled
                    />
                    <van-field
                            v-model="formInline.createTime"
                            label="创建时间"
                            disabled
                    />

                    <textAreaInput :remark="formInline.remark" @change="handleContentChange" :title="'备注'"
                                   :disabled="true"/>

                    <div v-for="(item, index) in dataList" :key="index">
                        <div class="flex-spa-bet list-tit-wrap">
                            <div class="left-tit">当前第{{ index + 1 }}期</div>
                            <van-icon name="refund-o" @click="handleUpdate(item)"/>
                        </div>

                        <van-field
                                v-model="item.collectionDate"
                                label="回款时间"
                                disabled
                        />

                        <van-field
                                v-model="item.planPrice"
                                label="回款金额"
                                disabled
                        />

                        <van-field
                                v-model="item.price"
                                label="已回金额"
                                disabled
                        />

                        <van-field
                                v-model="item.accountName"
                                label="回款账户"
                                disabled
                        />

                    </div>
                </van-form>
            </div>
        </div>

        <van-dialog
                v-model="showPicker"
                title="回款子计划"
                width="70%"
                style="font-size: 14px;"
                :showConfirmButton="false"
                :close-on-click-overlay="true"
        >
            <van-form validate-first>
                <van-field
                        v-model="subForm.planPrice"
                        label-width="80px"
                        style="line-height: 40px;"
                        label="计划金额"
                        disabled
                />

                <van-field
                        v-model="subForm.notYerPrice"
                        label-width="80px"
                        style="line-height: 40px;"
                        label="未还金额"
                        disabled
                />
                <van-field
                        v-model="subForm.price"
                        label-width="80px"
                        label="还款金额"
                        placeholder="请输入"
                        style="line-height: 40px;"
                        :required="true"
                        :rules="[{ required: true, message: '请输入还款金额' }]"
                />

                <van-field
                        readonly
                        clickable
                        :value="subForm.collectionDate"
                        label-width="80px"
                        style="line-height: 40px;"
                        label="还款日期"
                        placeholder="点击选择日期"
                        :required="true"
                        :rules="[{ required: true, message: '请选择始日期' }]"
                        @click="showPickerDate = true"
                />

                <van-field
                        readonly
                        clickable
                        v-model="subForm.accountName"
                        label="账户名称"
                        label-width="80px"
                        style="line-height: 40px;"
                        placeholder="请选择"
                        @click="showPickerAccount= true"
                        :required="true"
                        :rules="[{ required: true, message: '请选择账户名称' }]"
                />

                <van-field
                        v-model="subForm.remark"
                        label-width="80px"
                        style="line-height: 40px;"
                        label="备注"
                        placeholder="请输入"
                />
            </van-form>
            <van-button type="info" style="width: 100%;height: 30px;font-size: 18px" @click="submitFormSub">确认
            </van-button>
        </van-dialog>
        <van-calendar :min-date="minDate" v-model="showPickerDate"
                      @confirm="onConfirmDate($event)"/>

        <Account :showDialog="showPickerAccount" @handleClose="handleCloseAccount" @submitList="submitList"/>
    </div>
</template>
<script>
    import {getCollectionInfo, updateCollection} from '@/api/cw/collection/collection';
    import {formatDate} from "@/utils/ruoyi";
    import Account from '@/components/account'

    export default {
        components: {Account},
        data() {
            return {
                formInline: {},
                subForm: {},
                id: this.$route.query.id,
                showPickerDate: false,
                showPickerAccount: false,
                showPicker: false,
                minDate: new Date(2010, 0, 1),
                //明细数组
                dataList: []
            };
        },

        mounted() {
            //回显
            this.findDetail()
        },

        methods: {
            handleGoBack() {
                this.$router.go(-1)
            },

            //回显
            async findDetail() {
                let itemDetail = await getCollectionInfo({collectionId: this.id});
                itemDetail = itemDetail.data
                this.formInline = itemDetail;
                this.dataList = itemDetail.sub
            },

            //日期确认
            onConfirmDate(value) {
                this.subForm.collectionDate = formatDate(value, 'yyyy-MM-dd');
                this.showPickerDate = false;
            },

            //备注
            handleContentChange(val) {
                this.formInline.remark = val;
            },

            //账户关闭
            handleCloseAccount() {
                this.showPickerAccount = false
            },

            //账户提交
            submitList(id, name) {
                this.subForm.accountId = id;
                this.subForm.accountName = name;
                this.showPickerAccount = false
            },

            //编辑子计划
            async handleUpdate(item) {
                this.subForm = {
                    id: item.id,
                    accountId: undefined,
                    planPrice: item.planPrice,
                    notYerPrice: item.notYerPrice,
                    collectionDate: ''
                }
                this.showPicker = true
            },

            //提交
            async submitFormSub() {
                if (Number(this.subForm.price) > Number(this.subForm.notYerPrice)) {
                    this.$toast.fail("回款金额不能大于未回款金额");
                    return;
                }
                if (this.subForm.price < 0) {
                    this.$toast.fail("回款金额不能为负数");
                    return;
                }
                let formdata = new FormData();
                formdata.set("price", this.subForm.price);
                formdata.set("collectionDate", this.subForm.collectionDate);
                formdata.set("id", this.subForm.id);
                formdata.set("accountId", this.subForm.accountId);

                await updateCollection(formdata).then(() => {
                    this.$toast.success('操作成功');
                    this.showPicker = false;
                    this.findDetail()
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
  .base-tit {
    padding: 20px 30px;
    font-size: 24px;
    color: #666666;
  }

  .btn {
    width: 710px;
    height: 100px;
    background: #0091ff;
    border-radius: 6px 6px 6px 6px;
    margin: 118px auto 0;
    font-size: 38px;
  }

  .list-tit-wrap {
    padding: 24px 30px;
    font-size: 26px;
    color: #333333;
  }

  .add-btn {
    width: 750px;
    height: 110px;
    background: #ffffff;
    margin-bottom: 20px;
    text-align: center;
    line-height: 110px;
    font-size: 30px;
    color: #54afff;
    cursor: pointer;
  }

  // 导航样式 --start
  ::v-deep .van-hairline--bottom::after {
    border-bottom: none;
  }

  ::v-deep .van-nav-bar .van-icon {
    color: #000;
  }

  ::v-deep .van-nav-bar__content {
    height: 100px;
    line-height: 100px;
  }

  ::v-deep .van-nav-bar__arrow,
  ::v-deep .van-nav-bar .van-icon {
    font-size: 32px;
  }

  // 导航样式 --end
</style>
